import React, { useState } from 'react';
import '../Styles/Features.css';

const limitedFeatures = [
  {
    title: "1 Shout per Day",
    description: "Share one post each day, perfect for brief check-ins.",
    icon: "📢"
  },
  {
    title: "3 Filter Phrases",
    description: "Hide content with up to 3 custom phrases.",
    icon: "🚫"
  },
  {
    title: "Journal",
    description: "Access to a single Journal to write any private thoughts or ideas. Completely Private. Completely Offline.",
    icon: "📓"
  },
  {
    title: "Burn Letters",
    description: "Write your secret thoghts and watch them disappear. Completely Private. Completely Offline.",
    icon: "🔥"
  },
  {
    title: "Favorite Shouts",
    description: "Save your favorite shouts for later access.",
    icon: "⭐️"
  },
  {
    title: "Basic App Access",
    description: "Use the mobile app with basic functionality.",
    icon: "📱"
  }
];

const unlimitedFeatures = [
  {
    title: "Unlimited Shouts",
    description: "Express yourself freely with no daily posting limit.",
    icon: "📣"
  },
  {
    title: "25 Filter Phrases",
    description: "Customize and filter your feed with up to 25 phrases.",
    icon: "🔍"
  },
  {
    title: "Shout History",
    description: "Access and review all of your past posts anytime.",
    icon: "📜"
  },
  {
    title: "Web App Access",
    description: "Unlock full functionality of the Cyphr Void Web Beta platform.",
    icon: "🌐"
  },
  {
    title: "Drafts",
    description: "Save up to 50 Shouts to edit, post, or delete.",
    icon: "✏️"
  },
  {
    title: "Scheduled Shouts",
    description: "Plan ahead by scheduling up to 50 Shouts to go live later. Scheduled Shouts can be deleted anytime before posting.",
    icon: "⏰"
  },
  {
    title: "Supporter Badge",
    description: "Show your support with a unique badge on your Shouts.",
    icon: "♾️"
  },
  {
    title: "Mood Analytics",
    description: "Privatly visualize and reflect on your emotional trends.",
    icon: "😁"
  },
  {
    title: "Journal",
    description: "Up to 5 Journals to write any private thoughts or ideas. Completely Private. Completely Offline.",
    icon: "📓"
  },
  {
    title: "Burn Letters",
    description: "Write your secret thoghts and watch them disappear. Completely Private. Completely Offline.",
    icon: "🔥"
  },
  {
    title: "Favorite Shouts",
    description: "Save your favorite shouts for later access.",
    icon: "⭐️"
  },
  {
    title: "Delete Shouts",
    description: "Delete your own shouts up to 10 minutes after posting. Sometimes we just need to let go, but sometimes we say to ourselves, 'I'll save this for later.'",
    icon: "🗑️"
  }
];

function Features() {
  const [view, setView] = useState('unlimited');
  const features = view === 'limited' ? limitedFeatures : unlimitedFeatures;

  return (
    <div className="features-container">
      <h2>Void {view === 'limited' ? 'Limited' : 'Unlimited'} Features</h2>
      <div className="feature-toggle">
        <button className={view === 'limited' ? 'active' : ''} onClick={() => setView('limited')}>
          Void Limited (Free)
        </button>
        <button className={view === 'unlimited' ? 'active' : ''} onClick={() => setView('unlimited')}>
          Void Unlimited ($0.99/Week)
        </button>
      </div>
      <div className="features-list">
        {features.map((feature, index) => (
          <div key={index} className="feature-card">
            <span className="feature-icon">{feature.icon}</span>
            <h3>{feature.title}</h3>
            <p>{feature.description}</p>
          </div>
        ))}
      </div>
      <div>
        <p>* Void Unlimited is an option subscription.</p>
        <p>** Currently Subscriptions can only be purchased within the Cyphr Void App and managed within the Apple App Store.</p>
      </div>
    </div>
  );
}

export default Features;
